import { MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import {
  useMutation,
  useListContext,
  sanitizeFetchType,
  useNotify,
  useTranslate,
} from 'react-admin'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { PalmEventsRecurringDialog } from '../PalmDialogs'
import { BulkActionProps } from '../../../common/BulkActionsProps'
import { PalmDto } from '../../../../core/dto/device/palm/palm.dto'
import { DateTime } from '../../../../core/common/date-time'

export const PalmDetachEventRecurringBulkButton = ({
  selectedIds,
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  innerRef,
  ...props
}: BulkActionProps) => {
  const { loading, refetch } = useListContext<PalmDto>()
  const notify = useNotify()
  const translate = useTranslate()
  const hasAuthority = useHasAuthority()
  const [selectStateDialogOpen, setSelectStateDialogOpen] = useState(false)
  const [mutate, { loading: mutationLoading }] = useMutation()
  const [eventId, setEventId] = useState<number | undefined>()

  const handleMutation = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    const query = {
      type: sanitizeFetchType('detachDevices'),
      resource: ResourceName.EVENTS,
      payload: {
        eventId,
        verifierDevicesIds: selectedIds,
        recurringJobName,
        cronExpression,
        scheduledAt,
      },
    }
    const result = await mutate(query, {
      returnPromise: true,
      onFailure: (msg) => notify(msg, 'error'),
    })
    return result
  }

  const handleDetachEvents = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    setSelectStateDialogOpen(false)
    handleMutation(recurringJobName, cronExpression, scheduledAt)
    refetch()
  }

  const handleDialogClose = () => {
    setSelectStateDialogOpen(false)
  }

  return (
    <MenuItem
      {...props}
      disabled={
        !selectedIds.length ||
        !hasAuthority(Authority.EDIT_PALMS) ||
        loading ||
        mutationLoading
      }
      onClick={() => setSelectStateDialogOpen(true)}
      button
    >
      <Typography>
        {translate('resources.palms.actions.detachEvents-recurring')}
      </Typography>
      <PalmEventsRecurringDialog
        open={selectStateDialogOpen}
        close={handleDialogClose}
        setSelectedEventId={setEventId}
        handleAttachment={handleDetachEvents}
        method="detach"
      />
    </MenuItem>
  )
}
